import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faSpinner } from "@fortawesome/free-solid-svg-icons";
import Button from "components/base/Button";
import { useCriarBalanco } from "hooks/useBalanco";

interface BotaoCriarBalancoProps {
    variant?: "primary" | "secondary" | "success" | "danger" | "warning" | "info" | "light" | "dark" | "outline-primary" | "outline-secondary";
    size?: "sm" | "lg";
    className?: string;
    disabled?: boolean;
}

const BotaoCriarBalanco: React.FC<BotaoCriarBalancoProps> = ({
    variant = "primary",
    size,
    className = "",
    disabled = false
}) => {
    const criarBalancoMutation = useCriarBalanco();

    const handleCriarBalanco = async () => {
        try {
            await criarBalancoMutation.mutateAsync({});
        } catch (error) {
            // Erro será tratado pelo hook
            console.error('Erro ao criar balanço:', error);
        }
    };

    const isLoading = criarBalancoMutation.isPending;

    return (
        <Button
            variant={variant}
            size={size}
            className={className}
            onClick={handleCriarBalanco}
            disabled={disabled || isLoading}
            title="Criar novo balanço"
        >
            {isLoading ? (
                <>
                    <FontAwesomeIcon icon={faSpinner} spin className="me-2" />
                    Criando...
                </>
            ) : (
                <>
                    <FontAwesomeIcon icon={faPlus} className="me-2" />
                    Novo Balanço
                </>
            )}
        </Button>
    );
};

export default BotaoCriarBalanco; 